var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('widget',{attrs:{"title":"widgets.upcomingRoutes.title","icon":"mdi-routes-clock","route":"/routes/all"}},[_c('routes-list',{attrs:{"paddingless":"","routes":_vm.getUpcomingRoutes,"show-location":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }